
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/components/ui/use-toast";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

// Create a lightweight logging utility that only logs in development
const isDevelopment = import.meta.env.DEV;
const logger = {
  log: (...args: any[]) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  error: (...args: any[]) => {
    if (isDevelopment) {
      console.error(...args);
    }
  }
};

const PaymentSettingsForm = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { toast } = useToast();

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      setIsLoading(true);
      
      // Fetch payment settings
      const { data, error } = await supabase
        .from("payment_settings")
        .select("*")
        .single();
      
      if (error) throw error;
      
      // Set form data based on fetched settings
      // Implementation depends on your settings structure
      
    } catch (error: any) {
      logger.error("Error loading payment settings:", error);
      toast({
        title: "Failed to load settings",
        description: error.message,
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Card>
      <CardHeader>
        <h3 className="text-lg font-medium">Payment Gateway Settings</h3>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="flex justify-center py-8">
            <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
          </div>
        ) : (
          <div className="space-y-4">
            <p className="text-muted-foreground">
              Payment gateway configuration settings will appear here.
              To change API keys and other sensitive information, please use the Supabase dashboard.
            </p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default PaymentSettingsForm;
